import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';

@Component({
  selector: 'app-sale-submissions-popup',
  templateUrl: './sale-submissions-popup.component.html',
  styleUrls: ['./sale-submissions-popup.component.scss']
})
export class SaleSubmissionsPopupComponent extends BaseUnsubscribeComponent implements OnInit {

  @Input() public data: any;
  public saleSubmissionsForm: FormGroup;
  public submitted = false;

  constructor(
    public readonly modal: NgbActiveModal,
    private readonly formBuilder: FormBuilder
  ) {
      super();
  }

  public formSubmit(): void {
    this.submitted = true;

    if (this.saleSubmissionsForm.invalid) {
      return;
    }

    let formData = this.saleSubmissionsForm.value;
    formData.id = this.data.saleSubmissions.id;
    formData.statusId = this.data.saleSubmissions.statusId;

    this.modal.close(JSON.stringify(formData));
  }

  public ngOnInit(): void {

    this.saleSubmissionsForm = this.formBuilder.group({
      comments: ['', [Validators.required]]
    });
  }
}
